<script>
  import './exploreProjects.css'
  import ProjectCard from '../../components/project-card/ProjectCard.svelte'
  import { PROJECT_STATUSES, PROJECT_TAGS } from '../../constants/constants'
  import { projectType } from '../../store'
  import Pagination from '../../components/pagination/Pagination.svelte'
  import { fetchProjects } from '../../../services/projectDetailService'

  import queryString from 'query-string'
  import { NETWORK_CHAIN_IDS } from '../../constants/network'
  import { onMount } from 'svelte'

  let blockchain
  let projects = []
  let selected

  let blockchains = ['ALL'].concat(Object.keys(NETWORK_CHAIN_IDS))

  const url = window.location.href.split('/#').join()
  const queryUrl = queryString.parseUrl(url)

  onMount(() => {
    window.scroll({ top: 0 })

    let status = queryUrl.query.status
    let chain = queryUrl.query.blockchain

    if (!blockchains.includes(chain)) chain = 'ALL'

    blockchain = chain

    if (!options.includes(status)) status = options[1]
    selected = status

    fetchProject()
  })

  const COUNT_PER_PAGE = 12
  let totalCount = 0
  let options = ['All', 'Featured', 'Live', 'Upcoming', 'Completed', 'Flagged']
  let pagesCount = 0
  let currentPage = 1

  projectType.set(selected === 'Live' ? PROJECT_STATUSES.LIVE : selected)

  const fetchProject = async () => {
    let projectStatus
    switch (selected) {
      case 'Live':
        projectStatus = PROJECT_STATUSES.LIVE
        break
      case 'All':
        projectStatus = PROJECT_STATUSES.ALL
        break
      case PROJECT_STATUSES.UPCOMING:
        projectStatus = PROJECT_STATUSES.UPCOMING
        break
      case PROJECT_STATUSES.COMPLETED:
        projectStatus = PROJECT_STATUSES.COMPLETED
        break
      case PROJECT_TAGS.FEATURED:
        projectStatus = PROJECT_TAGS.FEATURED
        break
      case PROJECT_TAGS.FLAGGED:
        projectStatus = PROJECT_TAGS.FLAGGED
    }

    let projectResponse = await fetchProjects(
      projectStatus,
      NETWORK_CHAIN_IDS[blockchain],
      currentPage,
      COUNT_PER_PAGE,
    )
    const { data, meta } = projectResponse
    projects = [];
    projects = data
    totalCount = Number(meta.pagination.total)
    pagesCount = Math.ceil(totalCount / COUNT_PER_PAGE)
  }

  const onChangePage = (pageNumber) => {
    currentPage = pageNumber
    fetchProject()
  }
</script>

<div class="view-all-wrapper container">
  <div class="flex items-center header-listing">
    <h2 class="header-title">{selected} Sales</h2>
    <div class="ml-auto">
      <div class="explore">
        <label class="title">Project Status</label>
        <select
          bind:value={selected}
          on:change={async () => {
            window.history.replaceState({}, '', `#/${'explore-projects?status='}${selected}&blockchain=${blockchain}`)
            currentPage = 1;
            await fetchProject()
          }}>
          {#each options as value}
            <option {value}>{value}</option>
          {/each}
        </select>
      </div>

    </div>
    <div class="explore">
      <label class="title">Blockchains</label>

      <select
        bind:value={blockchain}
        on:change={async () => {
          window.history.replaceState({}, '', `#/${'explore-projects?status='}${selected}&blockchain=${blockchain}`)
          currentPage = 1;
          await fetchProject()
        }}>

        {#each blockchains as value}
          <option {value}>{value}</option>
        {/each}
      </select>
    </div>
  </div>
  {#if projects}
    <div class="preview-project-listing flex flex-wrap">
        {#each projects as project (project.id)}
            <ProjectCard {project} />
        {/each}
    </div>
  {/if}

  {#if totalCount > COUNT_PER_PAGE}
    <Pagination
      current={currentPage}
      count={pagesCount}
      setCurrentPage={onChangePage} />
  {/if}

</div>
